export default "__VITE_ASSET__jRV8P3ru__"